module.exports = __webpack_public_path__ + "img/jinxian.13fac905.png";